module.exports = __webpack_public_path__ + "img/2020-04-29.8bed0449.jpg";